import { render, staticRenderFns } from "./videoDate.vue?vue&type=template&id=5bdbeb13&scoped=true"
import script from "./videoDate.vue?vue&type=script&lang=js"
export * from "./videoDate.vue?vue&type=script&lang=js"
import style0 from "./videoDate.vue?vue&type=style&index=0&id=5bdbeb13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbeb13",
  null
  
)

export default component.exports